import { SearchableList } from '@platform/ui-library';
import AddForm from './AddForm';
import { Actions } from '../shared/update-array';
import styles from './UtteranceList.module.scss';

interface UtteranceListProps {
  utterances: string[];
  onChange: OnChangeUtterance;
  onImport?: () => void;
  onGenUtt?: () => void;
  disabled?: boolean;
  emptyMessage?: string;
}

export type OnChangeUtterance = (action: Actions<any>) => void;

export function UtteranceList(props: UtteranceListProps) {
  return (
    <>
      <div className={styles.header}>
        <AddForm
          disabled={props.disabled}
          type="phrases"
          placeholder="Add Utterance"
          onSubmit={(value) =>
            props.onChange({
              type: 'add',
              payload: {
                value
              }
            })
          }
          className={styles.addForm}
        />
        <span />
        <div className={styles.btnContainer}>
          <button
            type="button"
            className={styles.importButton}
            disabled={props.disabled}
            onClick={props.onImport}
          >
            <i className="fe icon-table" />
            Import from CSV
          </button>
          <button
            type="button"
            className={styles.importButton}
            disabled={props.disabled}
            onClick={props.onGenUtt}
          >
            <i className="fe icon-ai" />
            Generate Utterances
          </button>
        </div>
      </div>
      {props.utterances.length ? (
        <SearchableList
          hasCount
          hasSearch
          classes={{ root: styles.listContainer, list: styles.list }}
          label="Utterances"
          disabled={props.disabled}
          items={props.utterances.map((utt, i) => ({ id: i.toString(), value: utt }))}
          onDelete={(id) => props.onChange({ type: 'remove', payload: { id } })}
          onEdit={(item) =>
            props.onChange({
              type: 'update',
              payload: item
            })
          }
        />
      ) : (
        <p className={styles.message}>
          {props.emptyMessage}
        </p>
      )}
    </>
  );
}
